// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "4cbf94b-dirty",
    "hash": "4cbf94b",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "4cbf94b-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
